<template>
<div v-if="preloader" class="position-relative h-100">
    <app-overlay-loader />
  </div>
  <div  v-else>
    <div class="row">
      <div class="col-sm-10">
        <div>
          <h2 style="font-weight: 600; margin-bottom: 0.5rem !important">
            Membership Info
          </h2>
        </div>
      </div>
    </div>
      <div class="form-row">
        <div class="form-group col-6">
          <label for="user_first_name">{{ $t("Package Name") }}</label>
          <app-input type="text" :required="true" :read-only="true" v-model="this.membershipInfo.package.title"/>
        </div>
        <div class="form-group col-6">
          <label for="user_first_name">{{ $t("Package Amount") }}</label>
          <app-input type="text" :required="true" :read-only="true" v-model="this.membershipInfo.package.amount"/>
        </div>
      </div>
        <div class="form-row">
             <div class="form-group col-6">
          <label for="user_first_name">{{ $t("Package Start Date") }}</label>
          <app-input type="text" :required="true" :read-only="true" v-model="this.membershipInfo.start_date"/>
        </div>
        <div class="form-group col-6">
          <label for="user_first_name">{{ $t("Package End Date") }}</label>
          <app-input type="text" :required="true" :read-only="true" v-model='this.membershipInfo.end_date'/>
        </div>
      </div>
         <div class="form-row">
             <div class="form-group col-6">
          <label for="user_first_name">{{ $t("Package Duration") }}</label>
          <app-input type="text" :required="true" :read-only="true" v-model="this.pack_duration"/>
        </div>
      </div>
    <a href="/kanban-view">Go to Task Board</a>
      <task-form-progress v-if="showProgress == true" :actionType="false" :task_id="task_id" :taskForms="taskForms" :formProgress="formProgress" :overallProgress="overallProgress"></task-form-progress>
  </div>
</template>

<script>
import { FormMixin } from "../../../../core/mixins/form/FormMixin";
import { GET_PACKAGE_TASK} from "../../../Config/ApiUrl";
import { axiosGet } from "../../../Helpers/AxiosHelper";

export default {
  name: "CompanyInformation",
  mixins:[FormMixin],
  data() {
    return {
      pack_duration:null,
      preloader: true,
      membershipInfo: this.$store.state.userCompanyProfile.dataProfile.company,
      user_id: this.$store.state.userCompanyProfile.dataProfile.id,
      formProgress: {},
      overallProgress: 0,
      task_id: 0,
      taskForms: [],
      totalPercentage: 0,
      showProgress: false,
    };
  },
  methods: {
    getProgress() {
      var package_id = this.membershipInfo.package_id;
      axiosGet(GET_PACKAGE_TASK + "/" + package_id+'?user_id='+this.user_id)
        .then((response) => {
          if (response.data) {
            this.task_id = response.data.task.id;
            this.taskForms = response.data.task.task_forms_list;
            this.formProgress = response.data.formsProgress;
            this.overallProgress = response.data.overallProgress;
            this.showProgress = true;
          }
          this.preloader = false;
        })
        .catch((error) => {
          
        });
    },
  },
  mounted() {
      setTimeout(() => {
         this.preloader = false;
      }, 2000)
      this.pack_duration=this.membershipInfo.package.time_period + " " + this.membershipInfo.package.period;
      this.getProgress();
  },
};
</script>

<style>
.progress-style {
  text-align: center !important;
  /* color: #fff !important; */
  font-weight: bold !important;
  /* background-color: #292f4c !important; */
}

.form-progress .progress{
    width: 150px;
    height: 150px;
    line-height: 150px;
    background: none;
    margin: 0 auto;
    box-shadow: none;
    position: relative;
}
.form-progress .progress:after{
    content: "";
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 12px solid #fff;
    position: absolute;
    top: 0;
    left: 0;
}
.form-progress .progress > span{
    width: 50%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    z-index: 1;
}
.form-progress .progress .progress-left{
    left: 0;
}
.form-progress .progress .progress-bar{
    width: 100%;
    height: 100%;
    background: none;
    border-width: 12px;
    border-style: solid;
    position: absolute;
    top: 0;
}
.form-progress .progress .progress-left .progress-bar{
    left: 100%;
    border-top-right-radius: 80px;
    border-bottom-right-radius: 80px;
    border-left: 0;
    -webkit-transform-origin: center left;
    transform-origin: center left;
}
.form-progress .progress .progress-right{
    right: 0;
}
.form-progress .progress .progress-right .progress-bar{
    left: -100%;
    border-top-left-radius: 80px;
    border-bottom-left-radius: 80px;
    border-right: 0;
    -webkit-transform-origin: center right;
    transform-origin: center right;
    animation: loading-1 1.8s linear forwards;
}
.form-progress .card.card-with-shadow {
  box-shadow: none !important;
}
/* .form-progress .progress .progress-value{
    width: 30%;
    height: 330%;
    border-radius: 50%;
    background: #ffffff;
    font-size: 24px;
    color: #d10b4f;
    line-height: 135px;
    text-align: center;
    position: absolute;
    top: 5%;
    left: 5%;
}
.form-progress .progress.blue .progress-bar{
    border-color: #d10b4f;
}
.form-progress .progress.blue .progress-left .progress-bar{
    animation: loading-2 1.5s linear forwards 1.8s;
}






@keyframes loading-1{
    0%{
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100%{
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
    }
}
@keyframes loading-2{
    0%{
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100%{
        -webkit-transform: rotate(144deg);
        transform: rotate(144deg);
    }
}
@keyframes loading-3{
    0%{
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100%{
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
    }
}
@keyframes loading-4{
    0%{
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100%{
        -webkit-transform: rotate(36deg);
        transform: rotate(36deg);
    }
}
@keyframes loading-5{
    0%{
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100%{
        -webkit-transform: rotate(126deg);
        transform: rotate(126deg);
    }
}
@media only screen and (max-width: 990px){
    .progress{ margin-bottom: 20px; }
} */
</style>

